import { Link } from 'gatsby';
import React from 'react'
import styled from 'styled-components';


const Footer = () => {
  return (
    <Footercontainer>
       <FooterLinkWrapper>
           <FooterDesc>
              <h1>Travel</h1>
              <p>Exploer more place and enjoy the life</p>
           </FooterDesc>
           <FooterLinkItems>
               <FooterLinkTitle>Contact Us</FooterLinkTitle>
               <FooterLinks to="/about">Contact</FooterLinks>
               <FooterLinks to="/">Support</FooterLinks>
               <FooterLinks to="/">Destination</FooterLinks>
               <FooterLinks to="/">Sponsership</FooterLinks>
           </FooterLinkItems>
           </FooterLinkWrapper>
           <FooterLinkWrapper>
           <FooterLinkItems>
               <FooterLinkTitle>Videos</FooterLinkTitle>
               <FooterLinks to="/">New Video</FooterLinks>
               <FooterLinks to="/">Support</FooterLinks>
               <FooterLinks to="/">Places</FooterLinks>
               <FooterLinks to="/">About us</FooterLinks>
           </FooterLinkItems>
           <FooterLinkItems>
               <FooterLinkTitle>Socail Media</FooterLinkTitle>
               <FooterLinks to="/">Facebook</FooterLinks>
               <FooterLinks to="/">Twitter</FooterLinks>
               <FooterLinks to="/">Youtube</FooterLinks>
               <FooterLinks to="/">Orkut</FooterLinks>
           </FooterLinkItems>
       </FooterLinkWrapper>
    </Footercontainer>
  )
}

export default Footer

const Footercontainer = styled.div`
  padding:5rem calc((100vw - 1100px) /2);
  display:grid;
  grid-template-columns:repeat(2,1fr);
  color: #000;
  background:#fafafa;
`;
const FooterLinkWrapper = styled.div`
  display:grid;
  grid-template-columns:repeat(2,1fr);
  @media screen and (max-width:820px){
    grid-template-columns:1fr;
  }
`;
const FooterDesc = styled.div`
  padding:0 2rem;
  h1{
      margin-bottom:3rem;
      color: #f26a2e;
  }
  @media screen and (max-width:400px){
    padding:1rem;
  }
`;
const FooterLinkItems = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  padding:1rem 2rem;
  @media screen and (max-width:400px){
    padding:1rem;
  }
`;
const FooterLinkTitle = styled.h2`
    font-size:14px;
    margin-bottom:16px;
`;
const FooterLinks = styled(Link)`
    text-decoration:none;
    margin-bottom:0.5rem;
    font-size:14px;
    color: #3d3d4e;
    &:hover{
     color: #f26a2e;
     transition:0.3s ease-out;
    }
`;
